import script from "./AddonsDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddonsDetails.vue?vue&type=script&lang=ts&setup=true"

import "./AddonsDetails.vue?vue&type=style&index=0&id=64ae4b3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64ae4b3a"]])

export default __exports__